var map = {
	"./ChineseWu_Ext": [
		1225,
		147
	],
	"./ChineseWu_Ext.json": [
		1225,
		147
	],
	"./Spanish_Ext": [
		94706,
		134
	],
	"./Spanish_Ext.json": [
		94706,
		134
	],
	"./en_US": [
		33242,
		294
	],
	"./en_US.json": [
		33242,
		294
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 29747;
module.exports = webpackAsyncContext;